import React, { createContext } from 'react';

type TeamCollapsedState = {
  isTeamCollapsed?: boolean;
  setIsTeamCollapsed?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const TeamCollapsedContext = createContext<TeamCollapsedState>({});
